import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { ReactElement } from "react";

import AppContainer from "./AppContainer";
import { actionCreators } from "../store";

function App(): ReactElement {
  const dispatch = useDispatch();
  const { login } = bindActionCreators(actionCreators, dispatch);

  // const useCookie = (cookieName: string): string | null => {
  //   const [cookieValue, setCookieValue] = useState<string | null>(null); // Allow string or null

  //   useEffect(() => {
  //     const getCookieValue = () => {
  //       const cookies = document.cookie.split("; ");
  //       const targetCookie = cookies.find((cookie) =>
  //         cookie.startsWith(`${cookieName}=`)
  //       );

  //       return targetCookie
  //         ? decodeURIComponent(targetCookie.split("=")[1])
  //         : null;
  //     };
  //     setCookieValue(getCookieValue());
  //   }, [cookieName]);

  //   return cookieValue;
  // };

  // const username = useCookie("username") ?? "";
  // const password = useCookie("password") ?? "";

  const queryParams = new URLSearchParams(window.location.search);

  const payloadBase64Encoded = queryParams.get("payload") ?? "";

  const payload = JSON.parse(atob(payloadBase64Encoded));

  // Access specific query parameters
  const _zap_token = payload.token ?? "";
  const sid = payload.sid ?? undefined;

  login(_zap_token);

  return <AppContainer conversationSid={sid} />;
}

export default App;
